import * as PIXI from 'pixi.js';
import { ColorAttribute } from '../attributes';
import type { SerializableMixinSettings } from '../serializableMixin';
import { TypedSerializableMixin } from '../serializableMixin';

type AssetBoundsDisplaySettings = {
    strokeColor?: number;
    asset: object;
    referenceToOutputMultiplier?: number;
} & SerializableMixinSettings;

export class AssetBoundsDisplay extends TypedSerializableMixin(PIXI.Graphics) {
    override name = 'assetBoundsDisplay';
    @ColorAttribute()
    accessor strokeColor = 0;
    #strokeWidthInOutputResolution = 3;
    asset: object | undefined = undefined;
    #referenceToOutputMultiplier: number;

    constructor(settings: AssetBoundsDisplaySettings) {
        super(settings);
        this.strokeColor = settings.strokeColor ?? this.strokeColor;
        this.asset = settings.asset;
        this.#referenceToOutputMultiplier = settings.referenceToOutputMultiplier ?? 1;
        this._draw();
    }

    /**
     * Redraws from the current on-screen layout, which is not observable, so the owning scene calls this on every
     * seek instead of a reaction.
     * @internal
     */
    _draw() {
        if (!this.asset) {
            return;
        }
        this.clear();
        const { x, y, width, height } = (
            this.asset as { getBounds: () => PIXI.Rectangle }
        ).getBounds();
        const strokeWidth = Math.max(
            1,
            Math.round(this.#strokeWidthInOutputResolution / this.#referenceToOutputMultiplier),
        );
        this.rect(x, y, width, height);
        this.stroke({ width: strokeWidth, color: this.strokeColor, alpha: 1 });
    }
}
